/**
 * Compact initials for a display name — "Tom Verlinden" → "TV", single names take the
 * first two characters. Used for the participant-list avatars and the map rider badges.
 */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  return (parts.length > 1 ? parts[0][0] + parts[parts.length - 1][0] : name.slice(0, 2)) || '?';
}
